import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { DeleteCustomerCardComponent } from './delete-customer-card/delete-customer-card.component';
import { SetPaymentMethodComponent } from 'src/app/billing/payment-methods/set-payment-method/set-payment-method.component';
@Component({
  selector: 'app-edit-customer',
  templateUrl: './edit-customer.component.html',
  styleUrl: './edit-customer.component.scss',
  standalone: false
})
export class EditCustomerComponent {
  title: string = '';
  EditCustomer: any;
  billingForm: FormGroup;
  processing: any;
  userUuid: string = '';
  paymentMethods: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditCustomerComponent>,
    private fb: FormBuilder,
    public userService: UserService,
    public dialog: MatDialog
  ) {
    this.title = data.title;
    this.EditCustomer = data.value;
    this.userUuid = data.customerUuid;
    this.billingForm = this.fb.group({
      user_uuid: this.userUuid,
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      email: ['', Validators.required],
      address_1: ['', Validators.required],
      address_2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      zip_code: ['', Validators.required]
    });
  }
  displayUserPayment() {
    this.userService.getPaymentMethod().subscribe((result) => {
      this.paymentMethods = result.methods.payment_methods;
      console.log('this.paymentMethods', this.paymentMethods);

    });
  }
  ngOnInit() {
    this.displayUserPayment();
    console.log('EditCustomer:', this.EditCustomer);
  }

  save() {
    this.processing = true;

    this.userService.billingInfoUpdate(this.billingForm.value).subscribe({
      next: (response) => {
        setTimeout(() => {
          this.processing = false;
          // Close only after successful save
          this.dialogRef.close(true);
        }, 1000);
      },
      error: (err) => {
        this.processing = false;
        console.error('Update failed', err);
        // optionally show an error message instead of closing
      }
    });
  }

  close() {
    this.dialogRef.close('cancelDialog');
  }
  removeCard(cards: any) {

    const dialogRef = this.dialog.open(DeleteCustomerCardComponent, {
      id: 'DeleteCustomer',
      maxWidth: '400px',
      width: '100%',
      data: {
        value: cards,
      }
    });
    dialogRef.afterClosed().subscribe({
      next: (value) => {
        this.displayUserPayment();
      },
    })
  }
  cardDefault(method: any) {
    const dialogRef = this.dialog.open(SetPaymentMethodComponent, {
      width: '600px',
      data: { methods: method }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.primaryCard) {
        this.displayUserPayment();
      }
    });
  }
  deletecard(cards: any) {
    const dialogRef = this.dialog.open(DeleteCustomerCardComponent, {
      width: '600px',
      data: {
        value: cards,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.removeCard) {
        this.displayUserPayment();
      }
    });
  }
  getCardIcon(brand: string) {
    const map: any = {
      visa: 'https://cdn-icons-png.flaticon.com/512/196/196578.png',
      mastercard: 'https://cdn-icons-png.flaticon.com/512/196/196561.png',
      amex: 'https://cdn-icons-png.flaticon.com/512/349/349221.png',
      discover: 'https://cdn-icons-png.flaticon.com/512/349/349230.png',
      jcb: 'https://cdn-icons-png.flaticon.com/512/349/349228.png',
      diners: 'https://cdn-icons-png.flaticon.com/512/349/349222.png'
    };

    return map[brand] || 'https://cdn-icons-png.flaticon.com/512/565/565547.png';
  }

}
